import Header from "../utils/Header";
import FooterAgri from "../utils/FooterAgri";
import ImageWithOverlayPunjabAgri from "../utils/ImageWithOverlayPunjabAgri";
import AboutUs from "../../public/media/rs/rs_bg.jpg";
import PunjabAri from "./PunjabAgri";
import logoLeft from "../../public/media/rs/limsLogoGroup.png";
import logoRight from "../../public/media/rs/punjabAgriGroup.png";
export default function CompleteAbout() {
  return (
    <>
      <Header />
      <ImageWithOverlayPunjabAgri
        image={AboutUs}
        height="350px"
        title="Remote Sensing of Punjab"
        titlePartOne="Remote Sensing of"
        titlePartTwo="Punjab"
        logoLeft={logoLeft}
        logoRight={logoRight}
      />
      <PunjabAri />
      <FooterAgri />
    </>
  );
}
